import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SMBrand } from 'src/app/models/SMBrand';
import { BrandService } from '../crud/brand.service';
import { SMOrderBasic } from 'src/app/models/SMOrderBasic';
import { SMTimeSlot } from 'src/app/models/SMTimeSlot';

@Injectable({
  providedIn: 'root'
})
export class CreateOrderFlowService {

  private brandData = new BehaviorSubject(null);
  brand: Observable<SMBrand> = this.brandData.asObservable();
  brandID: string;

  constructor(private brandService: BrandService) { }

  setBrandID(brandID) {
    this.brandID = brandID;
  }

  getBrandID(): string {
    return this.brandID;
  }

  getBrand(): BehaviorSubject<any>  {
    return this.brandData;
  }

  updateBrand(brand: SMBrand) {
    this.brandData.next(brand);
  }

  async createOrder(order: SMOrderBasic): Promise<boolean> {
    return await this.brandService.createOrderRequest(this.brandID, this.brandData.value, order);
  }

  async getTimeSlots(date: Date): Promise<SMTimeSlot[]> {
    return await this.brandService.getTimeSLots(this.brandID, date);
  }
}
